// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payouts-table {
  width: 100%;
}

tbody:before {
    content:"@";
    display:block;
    line-height:10px;
    text-indent:-99999px;
}


.first_th{
  border-radius: 10px 0 0 10px;
}

.last_th{
  border-radius: 0 10px 10px 0;
}

.payouts_titleComponent {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.delete_filters{
  padding: 5px 10px;
  background-color: var(--bg);
  border-radius: 4px;
  border: solid 1px var(--bg);
  color: var(--text-primary);
}
.delete_filters:hover{
  padding: 5px 10px;
  background-color: #afb7ff;
  border-radius: 4px;
  border: solid 1px var(--primary);
  color: var(--text-primary);
}

/* styles.css (ou le nom de votre fichier CSS) */
.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  width: min-content;
  cursor: pointer;
  outline: none;
}

/* Style de survol lorsque la souris passe sur le select */
.custom-select:hover {
  border-color: var(--border);
}

/* Style de focus lorsque le select est en focus */
.custom-select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}


th {
  background-color: var(--bg);
  padding: 20px 10px;
  text-align: left;
}

.payout_modalContainer {
  position: block;
  width: 100%;
  height: 100%;
  background-color: aqua;
}

.payouts_filter_component {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
}

.payouts_filter_component input {
  width: max-content;
  border: 1px solid var(--border);
  padding: 5px 10px;
  border-radius: 4px;
}

.modal-button-div .valider{
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--success);
  border: solid 1px green;
  color: white;
}

.modal_hr_button{
  margin: 20px 0;
}

.modal-button-div .refuser{
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--danger);
  border: 1px solid var(--danger);
  color: white;
}


/***** WARNING EFFECT ********/

/**/
.warning_deleted{
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #F9E2E3;
  color: var(--text-primary);
  border: 1px solid var(--danger);
  padding: 8px 10px;
  border-radius: 7px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ago/AgoPayouts/agoPayouts.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,oBAAoB;AACxB;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,4BAA4B;EAC5B,gDAAgD;AAClD;;;AAGA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;AACd;;;AAGA,8BAA8B;;AAE9B,GAAG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".payouts-table {\n  width: 100%;\n}\n\ntbody:before {\n    content:\"@\";\n    display:block;\n    line-height:10px;\n    text-indent:-99999px;\n}\n\n\n.first_th{\n  border-radius: 10px 0 0 10px;\n}\n\n.last_th{\n  border-radius: 0 10px 10px 0;\n}\n\n.payouts_titleComponent {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delete_filters{\n  padding: 5px 10px;\n  background-color: var(--bg);\n  border-radius: 4px;\n  border: solid 1px var(--bg);\n  color: var(--text-primary);\n}\n.delete_filters:hover{\n  padding: 5px 10px;\n  background-color: #afb7ff;\n  border-radius: 4px;\n  border: solid 1px var(--primary);\n  color: var(--text-primary);\n}\n\n/* styles.css (ou le nom de votre fichier CSS) */\n.custom-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 14px;\n  width: min-content;\n  cursor: pointer;\n  outline: none;\n}\n\n/* Style de survol lorsque la souris passe sur le select */\n.custom-select:hover {\n  border-color: var(--border);\n}\n\n/* Style de focus lorsque le select est en focus */\n.custom-select:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n\nth {\n  background-color: var(--bg);\n  padding: 20px 10px;\n  text-align: left;\n}\n\n.payout_modalContainer {\n  position: block;\n  width: 100%;\n  height: 100%;\n  background-color: aqua;\n}\n\n.payouts_filter_component {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 10px;\n}\n\n.payouts_filter_component input {\n  width: max-content;\n  border: 1px solid var(--border);\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.modal-button-div .valider{\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--success);\n  border: solid 1px green;\n  color: white;\n}\n\n.modal_hr_button{\n  margin: 20px 0;\n}\n\n.modal-button-div .refuser{\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--danger);\n  border: 1px solid var(--danger);\n  color: white;\n}\n\n\n/***** WARNING EFFECT ********/\n\n/**/\n.warning_deleted{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #F9E2E3;\n  color: var(--text-primary);\n  border: 1px solid var(--danger);\n  padding: 8px 10px;\n  border-radius: 7px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
